import './styles.css';
import { useEffect, useRef, useState } from 'preact/hooks';
import usePromise from './hooks/use-promise';
import { getDomainAvailability, getDomainListings } from './data';
import TLDBadge from './components/tld-badge';
import { ProviderTLDMapping } from './constants';

function App() {
  const [name, setName] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [response, setResponse] = useState({});
  const timer = useRef();

  useEffect(() => {
    if (name.length < 3) {
      setResponse({});
      return;
    }

    getDomainAvailability(name, (res) => setResponse(res));
  }, [name]);

  const [domainListings] = usePromise(() => getDomainListings(name), {
    conditions: [name && name.length >= 3],
    defaultValue: {},
    dependencies: [name],
  });

  function onNameChange(e) {
    const newName = e.target.value;
    setDisplayName(newName);
    clearTimeout(timer.current);

    timer.current = setTimeout(() => {
      setName(newName);
    }, 500);
  }

  return (
    <div id="app" className="container">

      <div className="header">
        <h1 className="title">three.name</h1>
        <h2 className="subtitle">Instantly search availability across various blockchain domains</h2>
      </div>

      <input
        type="text"
        className="input input-domain is-large"
        onInput={onNameChange}
        value={displayName}
        placeholder="Type 3 characters or more"
      />

      <div style={{ flexGrow: 1 }}>
        {Object.keys(ProviderTLDMapping).map((provider) => (
          <div className="provider-container">
            <div className={`provider-logo provider-${provider}`}>
              <img alt={provider} title={provider} src={`/assets/${provider.toLowerCase()}.png`} />
            </div>

            <div className="tld-container">
              {ProviderTLDMapping[provider].map((tld) => (
                <TLDBadge
                  name={name}
                  provider={provider}
                  tld={tld}
                  tldInfo={response[tld]}
                  listing={domainListings.name === name ? domainListings[tld] : null}
                />
              ))}
            </div>
          </div>
        ))}
      </div>

      <h4>
        <a
          target="_blank"
          href="https://gitcoin.co/grants/6026/threename-instant-blockchain-domain-search-api-fo"
          rel="noreferrer"
        >
          Support three.name at Gitcoin
        </a>
      </h4>

      <div className="copyright">
        Copyright &copy; 2022 three.name
        <br />
        Disclaimer: Accuracy of results are not guaranteed. We take no responsibility
        for any loss that may occur to you by using our website.
      </div>

    </div>
  );
}

export default App;
